export const colorMixin = {
  data () {
    return {}
  },
  methods: {
    $_rgba (color, opacity) {
      if (color && color.rgb && opacity) {
        const rgb = `${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}`
        return `rgba(${rgb}, ${opacity})`
      }
    }
  }
}
